import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export enum BorderedContainerSizeEnum {
  SMALL = "small",
  REGULAR = "regular",
  LARGE = "large",
}

export const StyledBorderedContainer = styled.div<{
  $size?: BorderedContainerSizeEnum;
}>`
  border: 1px solid ${theme.colors.purple_2};
  padding: ${(props) =>
    props.$size === BorderedContainerSizeEnum.SMALL ? "20px" : "40px"};
  border-radius: ${(props) =>
    props.$size === BorderedContainerSizeEnum.SMALL
      ? `${theme.variables.border_radius_2}`
      : `${theme.variables.border_radius_1}`};
  width: 100%;
  box-sizing: border-box;
  position: relative;
  background-color: white;
`;

export const StyledBorderedLabel = styled.div<{
  $size?: BorderedContainerSizeEnum;
}>`
  height: 40px;
  margin-top: 20px;
  border: 1px solid ${theme.colors.purple_2};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: fit-content;
  padding: ${(props) =>
    props.$size === BorderedContainerSizeEnum.SMALL
      ? "6px"
      : props.$size === BorderedContainerSizeEnum.REGULAR
        ? "10px"
        : "12px"};
  position: absolute;
  left: 50%;
  top: -36px;
  transform: translateX(-50%);
  background-color: white;
  white-space: nowrap;
  border-radius: 100px;
`;
